import type { YasalBelge } from "../types"

import { SIRKET_BILGILERI as S } from "./sirket-bilgileri"

/**
 * Metin değiştiğinde versiyonu artır: kayıt formu onay kaydını bu değerle
 * gönderir, backend hangi metnin okunduğunu buradan bilir.
 */
export const KVKK_AYDINLATMA_VERSIYON = "2026-10-25.1"

/**
 * İsteğe bağlı ticari ileti onayı — aydınlatma metninden ayrı tutulur; kayıt
 * bu onaya bağlanamaz (KVKK açık rıza + 6563 sayılı Kanun).
 */
export const TICARI_ILETI_ONAY_METNI =
  "Kampanya ve yeniliklerden haberdar olmak için tarafıma e-posta, SMS ve telefon yoluyla ticari elektronik ileti gönderilmesine ve bu amaçla iletişim bilgilerimin işlenmesine onay veriyorum."

export const KVKK_AYDINLATMA_METNI: YasalBelge = {
  baslik: "Kişisel Verilerin İşlenmesine İlişkin Aydınlatma Metni",
  altBaslik: `${S.unvan} — ${S.platformAdi} Platformu`,
  versiyon: KVKK_AYDINLATMA_VERSIYON,
  tarih: "2026-10-25",
  giris: [
    {
      tip: "paragraf",
      metin: `${S.unvan} ("Şirket") olarak, ${S.alanAdi} adresinde sunduğumuz ${S.platformAdi} muhasebe platformu ("Platform") kapsamında işlediğimiz kişisel verileriniz hakkında, 6698 sayılı Kişisel Verilerin Korunması Kanunu ("KVKK") madde 10 ve Aydınlatma Yükümlülüğünün Yerine Getirilmesinde Uyulacak Usul ve Esaslar Hakkında Tebliğ uyarınca sizi bilgilendirmek isteriz.`,
    },
  ],
  bolumler: [
    {
      baslik: "1. Veri Sorumlusu",
      bloklar: [
        {
          tip: "tablo",
          basliklar: ["Bilgi", "Değer"],
          satirlar: [
            ["Unvan", S.unvan],
            ["Adres", S.adres],
            ["MERSİS No", S.mersisNo],
            ["E-posta", S.eposta],
            ["KEP adresi", S.kepAdresi],
          ],
        },
      ],
    },
    {
      baslik: "2. Bu Metnin Kapsamı",
      bloklar: [
        {
          tip: "paragraf",
          metin: "Bu metin; Platform'a kayıt olan kişileri, Platform'u kullanan mali müşavirleri, şirket yetkililerini ve bunların tanımladığı kullanıcıları (\"Kullanıcı\") ve internet sitemizi ziyaret edenleri kapsar.",
        },
        {
          tip: "paragraf",
          metin: "Kullanıcıların Platform'a yüklediği ya da Platform aracılığıyla işlediği mükellef, mükellef çalışanı, cari hesap ve benzeri üçüncü kişilere ait kişisel veriler bakımından veri sorumlusu ilgili Kullanıcı'dır (mali müşavir veya şirket); Şirket bu veriler bakımından yalnızca veri işleyen sıfatıyla, Kullanıcı'nın talimatları doğrultusunda hareket eder. Bu kişilerin aydınlatılması Kullanıcı'nın sorumluluğundadır.",
        },
      ],
    },
    {
      baslik: "3. İşlenen Kişisel Veri Kategorileri",
      bloklar: [
        {
          tip: "liste",
          maddeler: [
            "Kimlik: ad, soyad; şirket adına kayıtta unvan.",
            "İletişim: e-posta adresi, telefon numarası, adres (sözleşme ve fatura için).",
            "Müşteri işlem: hesap tipi (mali müşavir / şirket), müşteri kodu, paket ve paket talepleri, destek talepleri ve yazışmalar.",
            "Finans: ödeme ve havale kayıtları, fatura bilgileri (vergi dairesi, vergi / T.C. kimlik numarası).",
            "İşlem güvenliği: IP adresi, oturum ve giriş kayıtları, tek kullanımlık doğrulama kodu (OTP) kayıtları, işlem (log) kayıtları, tarayıcı ve cihaz bilgisi.",
            "Hukuki işlem: kullanım koşulları ve abonelik sözleşmesinin elektronik kabul kayıtları (kabul edilen metin sürümü, tarih ve saat, IP adresi, tarayıcı bilgisi), aydınlatma ve ticari ileti onay kayıtları.",
            "Pazarlama: yalnızca ayrıca onay vermeniz hâlinde ticari elektronik ileti tercihiniz.",
          ],
        },
      ],
    },
    {
      baslik: "4. İşleme Amaçları ve Hukuki Sebepler",
      bloklar: [
        {
          tip: "tablo",
          basliklar: ["Amaç", "Hukuki sebep (KVKK md. 5/2)"],
          satirlar: [
            [
              "Hesabın oluşturulması, e-posta doğrulaması, Platform hizmetinin sunulması ve abonelik sözleşmesinin kurulması / ifası",
              "(c) Sözleşmenin kurulması veya ifası",
            ],
            [
              "Paket, ödeme ve faturalandırma işlemlerinin yürütülmesi; ticari defter ve belgelerin saklanması",
              "(c) Sözleşmenin ifası; (ç) Hukuki yükümlülük (VUK, TTK)",
            ],
            [
              "Bilgi güvenliğinin sağlanması, yetkisiz erişimin ve kötüye kullanımın önlenmesi, log kayıtlarının tutulması",
              "(ç) Hukuki yükümlülük (5651 sayılı Kanun); (f) Meşru menfaat",
            ],
            [
              "Destek taleplerinin ve şikâyetlerin yanıtlanması, hizmetle ilgili bilgilendirme yapılması",
              "(c) Sözleşmenin ifası; (f) Meşru menfaat",
            ],
            [
              "Hizmetin iyileştirilmesi ve kullanım istatistiklerinin (mümkün olduğunca anonim) çıkarılması",
              "(f) Meşru menfaat",
            ],
            [
              "Hukuki uyuşmazlıklarda hakların tesisi, kullanılması veya korunması",
              "(e) Bir hakkın tesisi, kullanılması veya korunması",
            ],
            [
              "Yetkili kamu kurum ve kuruluşlarının bilgi taleplerinin karşılanması",
              "(ç) Hukuki yükümlülük",
            ],
            [
              "Kampanya ve yeni hizmetlerin tanıtımı amacıyla ticari elektronik ileti gönderilmesi",
              "Açık rıza (KVKK md. 5/1) ve 6563 sayılı Kanun uyarınca ayrıca alınan onay — isteğe bağlıdır, hizmet kullanımının şartı değildir",
            ],
          ],
        },
      ],
    },
    {
      baslik: "5. Kişisel Verilerin Toplanma Yöntemi",
      bloklar: [
        {
          tip: "paragraf",
          metin: "Kişisel verileriniz; kayıt formu, Platform'un kullanımı, e-posta, telefon ve mesajlaşma kanalları, elektronik onay kayıtları ile zorunlu çerezler aracılığıyla, otomatik ve kısmen otomatik yöntemlerle, elektronik ve fiziki ortamda toplanır.",
        },
      ],
    },
    {
      baslik: "6. Kişisel Verilerin Aktarılması",
      bloklar: [
        {
          tip: "paragraf",
          metin: "Kişisel verileriniz, yukarıdaki amaçlarla sınırlı olmak üzere ve KVKK md. 8 ve 9'a uygun olarak aşağıdaki alıcı gruplarına aktarılabilir:",
        },
        {
          tip: "liste",
          maddeler: [
            "Barındırma, altyapı, içerik dağıtım ve e-posta gönderim hizmeti aldığımız tedarikçiler (sunucu konumu: [●]).",
            "Ödeme ve havale işlemlerinin doğrulanması için bankalar.",
            "Mali müşavir, bağımsız denetim ve hukuk danışmanlarımız.",
            "Talep hâlinde yetkili kamu kurum ve kuruluşları ile adli makamlar.",
          ],
        },
        {
          tip: "paragraf",
          metin: "Yurt dışında yerleşik tedarikçilere aktarım yapılması hâlinde bu aktarım KVKK md. 9'da öngörülen güvencelerle (ör. Kurul'a bildirilen standart sözleşme) gerçekleştirilir. Yurt dışına aktarım yapılan tedarikçiler: [●].",
        },
      ],
    },
    {
      baslik: "7. Saklama Süreleri",
      bloklar: [
        {
          tip: "liste",
          maddeler: [
            "Hesap ve sözleşme verileri: sözleşme süresince ve sona ermesinden itibaren genel zamanaşımı süresi olan 10 yıl.",
            "Fatura ve ödeme kayıtları: VUK ve TTK uyarınca 10 yıl.",
            "Trafik ve log kayıtları: 5651 sayılı Kanun uyarınca en az 1, en fazla 2 yıl.",
            "Doğrulanmamış kayıt talepleri: 30 gün; süre sonunda otomatik olarak silinir.",
            "Ticari elektronik ileti onayı: onayın geri alınmasından itibaren 3 yıl.",
          ],
        },
        {
          tip: "paragraf",
          metin: "Süresi dolan kişisel veriler, Kişisel Verilerin Silinmesi, Yok Edilmesi veya Anonim Hale Getirilmesi Hakkında Yönetmelik uyarınca silinir, yok edilir veya anonim hâle getirilir.",
        },
      ],
    },
    {
      baslik: "8. KVKK Madde 11 Kapsamındaki Haklarınız",
      bloklar: [
        {
          tip: "paragraf",
          metin: "Şirket'e başvurarak kişisel verilerinizle ilgili olarak;",
        },
        {
          tip: "liste",
          maddeler: [
            "İşlenip işlenmediğini öğrenme ve işlenmişse buna ilişkin bilgi talep etme,",
            "İşlenme amacını ve amacına uygun kullanılıp kullanılmadığını öğrenme,",
            "Yurt içinde veya yurt dışında aktarıldığı üçüncü kişileri bilme,",
            "Eksik veya yanlış işlenmişse düzeltilmesini isteme,",
            "KVKK md. 7'de öngörülen şartlar çerçevesinde silinmesini veya yok edilmesini isteme,",
            "Düzeltme, silme ve yok etme işlemlerinin verilerin aktarıldığı üçüncü kişilere bildirilmesini isteme,",
            "Münhasıran otomatik sistemlerle analiz edilmesi sonucu aleyhinize bir sonucun ortaya çıkmasına itiraz etme,",
            "Kanuna aykırı işleme nedeniyle zarara uğramanız hâlinde zararın giderilmesini talep etme",
          ],
        },
        { tip: "paragraf", metin: "haklarına sahipsiniz." },
      ],
    },
    {
      baslik: "9. Başvuru Yöntemi",
      bloklar: [
        {
          tip: "paragraf",
          metin: "Haklarınıza ilişkin taleplerinizi, Veri Sorumlusuna Başvuru Usul ve Esasları Hakkında Tebliğ uyarınca kimliğinizi tespit edici bilgilerle birlikte;",
        },
        {
          tip: "liste",
          maddeler: [
            `Islak imzalı dilekçe ile ${S.adres} adresine elden veya iadeli taahhütlü posta / noter kanalıyla,`,
            `Güvenli elektronik imza veya mobil imza ile ya da kayıtlı elektronik posta (KEP) üzerinden ${S.kepAdresi} adresine,`,
            `Platform'da kayıtlı e-posta adresinizden ${S.eposta} adresine`,
          ],
        },
        {
          tip: "paragraf",
          metin: "iletebilirsiniz. Başvurunuz, niteliğine göre en geç 30 gün içinde ücretsiz olarak sonuçlandırılır; işlemin ayrıca bir maliyet gerektirmesi hâlinde Kişisel Verileri Koruma Kurulu'nca belirlenen tarifedeki ücret alınabilir.",
        },
      ],
    },
  ],
}
